import { HTMLAttributes } from 'react'
import { cn } from '@/utils/cn'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  /** Full-bleed without horizontal padding (e.g. edge-to-edge grids) */
  flush?: boolean
  /** Optional centered reading column (~1200px) when needed */
  narrow?: boolean
}

export function Container({ className, flush, narrow, ...props }: ContainerProps) {
  return (
    <div
      className={cn(
        'eh-container',
        flush && 'eh-container--flush',
        narrow && 'eh-container--narrow',
        className,
      )}
      {...props}
    />
  )
}

export default Container
